// @flow
import * as React from 'react';
import type { Element } from 'react';
import styled from 'styled-components';
import { ml, mt, pt } from 'styled-components-spacing';
import breakpoint from 'styled-components-breakpoint';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhoneAlt, faMobileAlt } from '@fortawesome/free-solid-svg-icons';
import theme from '@theme';
import { CurefyLogoFooter } from '@images/svg/index';
import type { ContactInfoFooter } from './types';
import FooterYapitaLogo from './FooterYapitaLogo';

const ContactInfos = styled.div`
  ${mt(4.5)}
  text-align: left;
`;

const ContactInfo = styled.a`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  ${mt(3)}
  ${pt(1)}
  font-size: 20px;

  text-decoration: none;
  color: ${props => (props.curefyDomain ? 'rgb(1, 57, 57)' : theme.colors.translucentWhite80)};

  transition: all 0.5s ease;

  svg,
  path {
    fill: ${props => (props.curefyDomain ? 'rgb(1, 57, 57)' : theme.colors.white)};
    stroke: ${props => (props.curefyDomain ? 'rgb(1, 57, 57)' : theme.colors.white)};
  }
 
  &:hover {
    color: ${props => (props.curefyDomain ? 'rgb(16 182 50)' : theme.colors.defaultGreen)};

    svg,
    path {
      fill: ${props => (props.curefyDomain ? 'rgb(16 182 50)' : theme.colors.defaultGreen)};
      stroke: ${props => (props.curefyDomain ? 'rgb(16 182 50)' : theme.colors.defaultGreen)};
    }
  }
`;

const ContactInfoLabel = styled.div`
  font-weight: bold;
  font-size: 20px;
  ${ml(3)}
  color:${props => (props.curefyDomain ? 'rgb(1,57,57)' : theme.colors.translucentWhite80)};
  word-break: break-all;
`;

const StyledCurefy = styled(CurefyLogoFooter)`
  width:214px;
  height:100px;
  ${breakpoint('mobile', 'desktop')`
    width: 200px;
    height: 80px;
  `}
`;

const FooterContactInfo = ({ curefyDomain }: ContactInfoFooter): Element<any> => (
  <>
    {curefyDomain ? <StyledCurefy /> : <FooterYapitaLogo /> }

    <ContactInfos>
      <ContactInfo href="tel:+919599818171" curefyDomain={curefyDomain}>
        <FontAwesomeIcon icon={faPhoneAlt} size="1x" />
        <ContactInfoLabel curefyDomain={curefyDomain}>+91 95998 18171</ContactInfoLabel>
      </ContactInfo>
      <ContactInfo href="tel:+918056005099" curefyDomain={curefyDomain}>
        <FontAwesomeIcon icon={faMobileAlt} size="1x" />
        <ContactInfoLabel curefyDomain={curefyDomain}>+91 80560 05099</ContactInfoLabel>
      </ContactInfo>
      <ContactInfo href={curefyDomain ? 'mailto:support@curefy.ai' : 'mailto:support@yapitahealth.com'} curefyDomain={curefyDomain}>
        <FontAwesomeIcon icon={faEnvelope} size="1x" />
        <ContactInfoLabel curefyDomain={curefyDomain}>
          {curefyDomain
            ? <>support@curefy.ai</>
            : <> support@yapitahealth.com</>}
        </ContactInfoLabel>
      </ContactInfo>
    </ContactInfos>
  </>
);

export default FooterContactInfo;
